import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetCreditFacilitiesApi } from './use-get-credit-facilities-api';

const endpoint = 'ums/v1/cms/bnpl/credit-facilities';

type TData = Record<string, any>;
type TError = AxiosError;
type TVariables = { facilityId: number; body: { creditLimit: number } };
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUpdateCreditLimitApi(options?: Options): ReturnType {
  const { refetch: refetchFacilities } = useGetCreditFacilitiesApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ facilityId, body }: TVariables) => {
    try {
      const { data } = await http.patch(`${endpoint}/${facilityId}/limit`, body);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [`${endpoint}/limit`],
    onSuccess: () => {
      refetchFacilities();
      toast({ description: 'Credit limit updated successfully', status: 'success' });
    },
  });
}
